import type { ComponentType } from "react";
import DropdownTreeSelectModule from "react-dropdown-tree-select";
import type { DropdownTreeSelectProps } from "react-dropdown-tree-select";

const dropdownTreeSelectModule = DropdownTreeSelectModule as unknown as
  | ComponentType<DropdownTreeSelectProps>
  | {
      default: ComponentType<DropdownTreeSelectProps>;
    };

const DropdownTreeSelect =
  typeof dropdownTreeSelectModule === "function"
    ? dropdownTreeSelectModule
    : dropdownTreeSelectModule.default;

export default DropdownTreeSelect;
